import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useTargetMessages } from 'src/hooks/useTargetMessages';
import { FAQItem } from 'src/containers/FAQList';
import { getExternalLinkFormatters } from 'src/utils/externalLinkFormatters';
import * as S from './styles';
import * as msgsData from './messages';

const { msgs, ...localesWithMessages } = msgsData;

const externalLinkFormatters = getExternalLinkFormatters(S.Link);

export const MoviesFAQ = () => {
  const intl = useIntl();
  const targetMsgs = useTargetMessages(localesWithMessages);

  const questions = useMemo(
    () => [
      {
        question: intl.formatMessage(targetMsgs.immersiveLearningQuestion),
        answer: (
          <>
            {intl.formatMessage(targetMsgs.immersiveLearningAnswerPart1, externalLinkFormatters)}
            <br />
            <br />
            {intl.formatMessage(targetMsgs.immersiveLearningAnswerPart2)}
          </>
        ),
      },
      {
        question: intl.formatMessage(targetMsgs.educationalEntertainmentQuestion),
        answer: (
          <>
            {intl.formatMessage(targetMsgs.educationalEntertainmentAnswerPart1)}
            <br />
            <br />
            {intl.formatMessage(targetMsgs.educationalEntertainmentAnswerPart2)}
          </>
        ),
      },
      {
        question: intl.formatMessage(targetMsgs.learnWithMoviesQuestion),
        answer: intl.formatMessage(targetMsgs.learnWithMoviesAnswer, externalLinkFormatters),
      },
      {
        question: intl.formatMessage(targetMsgs.howMuchTimeQuestion),
        answer: intl.formatMessage(targetMsgs.howMuchTimeAnswer),
      },
      {
        question: intl.formatMessage(msgs.subtitlesQuestion),
        answer: intl.formatMessage(targetMsgs.subtitlesAnswer),
      },
    ],
    [targetMsgs, intl],
  );

  return (
    <S.Section>
      <S.Title>{intl.formatMessage(targetMsgs.title)}</S.Title>
      {questions.map(({ question, answer }) => (
        <FAQItem key={question} question={question} answer={answer} />
      ))}
    </S.Section>
  );
};
